/* eslint-disable react/prop-types */
import React from 'react'
import * as constants from '../../common/constants'
import { InputLabel, Select, MenuItem } from '@mui/material'
import FormControl from '@mui/material/FormControl'
// import { useTranslation } from 'react-i18next'
const Dropdown = ({ label, options, value, onChange }) => {
  // const { t } = useTranslation()
  return (
    <>
      <FormControl sx={{ m: 1, width: constants.ITEM_WIDTH }} size={'small'}>
        <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
          {label}
        </InputLabel>
        <Select
          value={value}
          onChange={onChange}
          defaultValue=''
          id='grouped-select'
          label=' Grouping '
        >
          <MenuItem value=''>
            <em>{constants.defaultSelect}</em>
          </MenuItem>
          {options?.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  )
}
export default Dropdown
